import { render, staticRenderFns } from "./CreateAutoActionFormStep4.vue?vue&type=template&id=ad22905a&scoped=true&"
import script from "./CreateAutoActionFormStep4.vue?vue&type=script&lang=ts&"
export * from "./CreateAutoActionFormStep4.vue?vue&type=script&lang=ts&"
import style0 from "./CreateAutoActionFormStep4.vue?vue&type=style&index=0&id=ad22905a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad22905a",
  null
  
)

export default component.exports